import React, { PropsWithChildren, useEffect, useState } from "react";
import { Redirect, useLocation } from "react-router";
import Cookies from "js-cookie";

import { useLoginStateProvider } from "../LoginStateProvider";
import { Route } from "react-router-dom";

const AWS_INTEGRATIONS = ["DefaultAwsCloudIntegration", "ManualAwsIntegration", "FileSystemCloudIntegration"];
const REDSHIFT_COOKIE_NAME = "redshift-partner";

export function useRedshiftPartner() {
  const { status } = useLoginStateProvider();

  const get = (remove: boolean) => {
    if (
      status?.selectedOrganization?.cloudIntegrations.some((integ: { clazz: string }) =>
        AWS_INTEGRATIONS.includes(integ.clazz)
      ) ||
      status?.noOrg
    ) {
      const redshiftParams = Cookies.get(REDSHIFT_COOKIE_NAME);

      if (remove) {
        Cookies.remove(REDSHIFT_COOKIE_NAME);
      }

      return redshiftParams;
    }

    return null;
  };

  return { get };
}

export function RedshiftPartnerRedirect() {
  const { status } = useLoginStateProvider();
  const { get } = useRedshiftPartner();

  const [redshiftParams, setRedshiftParams] = useState<string>();

  useEffect(() => {
    const redshiftParams = get(false);
    if (redshiftParams) {
      setRedshiftParams(redshiftParams);
    }
  }, [status]);

  if (redshiftParams) {
    return <Redirect to="/connections/create/RedshiftConnection" />;
  }

  return <></>;
}

function CookieSetter() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const redshiftParams = new URLSearchParams(search);
    // console.log(`Setting redshift partner console parameters: ${redshiftParams}`);
    if (redshiftParams.toString()) {
      Cookies.set(REDSHIFT_COOKIE_NAME, Object.fromEntries(redshiftParams.entries()));
    }
  }, [pathname, search]);

  return null as JSX.Element;
}

export default function RedshiftPartner(props: PropsWithChildren<{}>) {
  return (
    <>
      <Route path="/amazon-redshift-console" component={CookieSetter} />
      {props.children}
    </>
  );
}
